import React, { useCallback } from "react";
import { ChakraProps } from "@chakra-ui/react";
import { AsyncSearchProvider } from "./AsyncSearchProvider";
import AsyncSelect from "./AsyncSelect";
import useDungeons from "../../hooks/quests/useDungeonIds";

interface SelectDungeonProps extends ChakraProps {
  value: string;
  setValue: (value: string) => void;
}

const SelectDungeon: React.FC<SelectDungeonProps> = ({ color, value, setValue, ...chakraProps }) => {
  const { isLoading, error, dungeonIds = [] } = useDungeons();

  const handleSearch = useCallback(
    async (searchQuery?: string): Promise<[string, string][]> => {
      return dungeonIds
        .filter((dungeonId) => dungeonId.toLowerCase().includes(searchQuery?.toLowerCase().trim() ?? ""))
        .map((dungeonId) => [dungeonId, dungeonId]);
    },
    [dungeonIds]
  );

  return (
    <AsyncSearchProvider onSearchAsync={handleSearch}>
      <AsyncSelect
        selectedValue={value}
        setSelectedValue={setValue}
        title={"Dungeon"}
        color={color}
        isLoading={isLoading}
        error={error}
        {...chakraProps}
      />
    </AsyncSearchProvider>
  );
};

export default SelectDungeon;
